(function () {
  const messages = {
    en: {
      bannerTitle: "Order Requirements",
      ruleItem: (ok) => `${ok ? '✅' : '❌'} Minimum 20 units per item ${ok ? '(met)' : '— some items below minimum'}`,
      ruleTotal: (ok, total) => `${ok ? '✅' : '❌'} Minimum 100 units total ${ok ? `(current: ${total})` : `(current: ${total}, need ${100 - total} more)`}`,
      ruleNote: "Both conditions must be met before checkout.",
      errorItem: (title, qty) => `"${title}" requires a minimum of 20 units (current: ${qty}).`,
      errorTotal: (total) => `Cart total must be at least 100 units (current: ${total}).`,
      errorTitle: "Please fix the following before checking out:"
    },
    ja: {
      bannerTitle: "ご注文条件",
      ruleItem: (ok) => `${ok ? '✅' : '❌'} 各商品につき最低20個以上 ${ok ? '（条件クリア）' : '— 条件未達の商品があります'}`,
      ruleTotal: (ok, total) => `${ok ? '✅' : '❌'} 合計数量100個以上 ${ok ? `（現在：${total}個）` : `（現在：${total}個、あと${100 - total}個必要）`}`,
      ruleNote: "上記2つの条件を両方満たした場合のみチェックアウトできます。",
      errorItem: (title, qty) => `「${title}」は最低20個以上ご購入ください（現在：${qty}個）。`,
      errorTotal: (total) => `合計数量は100個以上必要です（現在：${total}個）。`,
      errorTitle: "チェックアウト前に以下をご確認ください："
    }
  };

  function getLang() {
    const locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    return locale.startsWith('ja') ? 'ja' : 'en';
  }

  // ── Find the best anchor element inside cart drawer or cart page ────────────
  function getBannerAnchor() {
    // Cart drawer footer
    const drawerFooter = document.querySelector('.cart-drawer__footer, .cart__footer, [class*="cart-drawer"] .buy-buttons, [class*="cart-drawer"] form');
    if (drawerFooter) return drawerFooter;
    // Cart page form
    const cartForm = document.querySelector('form[action="/checkout"], form[action*="cart"]');
    if (cartForm) return cartForm;
    return null;
  }

  // ── Render persistent banner ────────────────────────────────────────────────
  function renderBanner(cart) {
    const lang = getLang();
    const m = messages[lang];

    let totalQty = 0;
    let itemOk = true;
    (cart.items || []).forEach(item => {
      totalQty += item.quantity;
      if (item.quantity < 20) itemOk = false;
    });
    const totalOk = totalQty >= 100;

    let banner = document.getElementById('cart-rules-banner');
    const anchor = getBannerAnchor();
    if (!anchor) return;

    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'cart-rules-banner';
      banner.style.cssText = 'border-radius:6px;padding:12px 16px;margin-bottom:14px;font-size:13px;line-height:1.8;border:1px solid #bee3f8;background:#ebf8ff;color:#2b6cb0;';
      anchor.parentNode.insertBefore(banner, anchor);
    }

    if (itemOk && totalOk) {
      banner.style.borderColor = '#9ae6b4';
      banner.style.background = '#f0fff4';
      banner.style.color = '#276749';
    } else {
      banner.style.borderColor = '#bee3f8';
      banner.style.background = '#ebf8ff';
      banner.style.color = '#2b6cb0';
    }

    banner.innerHTML = `
      <strong style="display:block;margin-bottom:4px;font-size:14px;">${m.bannerTitle}</strong>
      <div>${m.ruleItem(itemOk)}</div>
      <div>${m.ruleTotal(totalOk, totalQty)}</div>
      <div style="margin-top:6px;font-size:11px;opacity:0.75;">${m.ruleNote}</div>
    `;
  }

  // ── Show checkout error ─────────────────────────────────────────────────────
  function showErrors(errors, referenceEl) {
    let errorDiv = document.getElementById('cart-validation-errors');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.id = 'cart-validation-errors';
      errorDiv.style.cssText = 'border:1px solid #e53e3e;background:#fff5f5;color:#c53030;padding:12px 16px;margin-bottom:12px;border-radius:4px;font-size:13px;line-height:1.6;';
      if (referenceEl && referenceEl.parentNode) {
        referenceEl.parentNode.insertBefore(errorDiv, referenceEl);
      } else {
        const anchor = getBannerAnchor();
        if (anchor) anchor.parentNode.insertBefore(errorDiv, anchor);
      }
    }
    const m = messages[getLang()];
    errorDiv.innerHTML = `<strong>${m.errorTitle}</strong><ul style="margin:6px 0 0 18px;padding:0;">${errors.map(e => `<li>${e}</li>`).join('')}</ul>`;
    errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearErrors() {
    const el = document.getElementById('cart-validation-errors');
    if (el) el.remove();
  }

  // ── Fetch cart and refresh banner ───────────────────────────────────────────
  async function refreshBanner() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.item_count > 0) renderBanner(cart);
    } catch (e) {
      console.warn('Cart banner refresh failed:', e);
    }
  }

  // ── Validate and intercept checkout ────────────────────────────────────────
  async function validateCart(e) {
    e.preventDefault();
    e.stopPropagation();
    clearErrors();

    const m = messages[getLang()];
    const errors = [];

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      let totalQty = 0;

      (cart.items || []).forEach(item => {
        totalQty += item.quantity;
        if (item.quantity < 20) {
          errors.push(m.errorItem(item.product_title || item.title, item.quantity));
        }
      });

      if (totalQty < 100) errors.push(m.errorTotal(totalQty));
    } catch (err) {
      console.error('Cart validation error:', err);
      window.location.href = '/checkout';
      return;
    }

    if (errors.length > 0) {
      showErrors(errors, e.currentTarget);
    } else {
      window.location.href = '/checkout';
    }
  }

  // ── Attach listeners (works for both drawer and cart page) ─────────────────
  function attachListeners() {
    const checkoutSelectors = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href="/checkout"]',
      'a[href*="/checkout"]',
      '[data-checkout-btn]'
    ];

    checkoutSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if (!el.dataset.cvBound) {
          el.dataset.cvBound = '1';
          el.addEventListener('click', validateCart);
        }
      });
    });

    // Intercept any form that submits to checkout
    document.querySelectorAll('form[action="/checkout"], form[action*="checkout"]').forEach(form => {
      if (!form.dataset.cvBound) {
        form.dataset.cvBound = '1';
        form.addEventListener('submit', validateCart);
      }
    });
  }

  // ── Init ────────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    refreshBanner();
    attachListeners();

    // Re-attach when cart drawer opens or DOM changes (Impact theme uses dynamic rendering)
    const observer = new MutationObserver(function (mutations) {
      let shouldRefresh = false;
      mutations.forEach(m => {
        if (m.addedNodes.length > 0) shouldRefresh = true;
      });
      if (shouldRefresh) {
        attachListeners();
        refreshBanner();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Quantity change events
    document.addEventListener('change', function (e) {
      if (e.target.matches('[name="updates[]"], [name^="updates"], [data-quantity-input], input[type="number"]')) {
        setTimeout(refreshBanner, 500);
      }
    });

    // Theme custom events
    document.addEventListener('cart:updated', refreshBanner);
    document.addEventListener('cart:refresh', refreshBanner);
  });
})();
